import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const regionApi = createApi({
    reducerPath: 'regionApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["Region"],
    endpoints: (builder) => ({
        getRegion: builder.query({
            query: () => `regionList`,
            providesTags: ["Region"],
        }),
        addRegion: builder.mutation({
            query: (newRegion) => ({
                url: 'region',
                method: 'POST',
                body: newRegion,
            }),
            invalidatesTags: ['Region'],
        }),
        deleteRegion: builder.mutation({
            query: ({ id }) => ({
                url: `region/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Region'],
        }),
        getRecipients: builder.query({
            query: (guid) => {
                return {
                    url: 'recieverList',
                    params: {
                        currentUser: guid
                    }
                }
            },
        }),
    }),
})

export const { useGetRegionQuery, useAddRegionMutation, useDeleteRegionMutation, useGetRecipientsQuery } = regionApi